/*====================================================================================
2026-09-21: Is used for posts, jobs and talents to be displayed in social feed. 
=====================================================================================*/


"use client"
import Alert from "@/components/Atoms/Alerts/Alert";
import { ArrowUpButton, CommentButton, ConfirmOrCancelButton, CopyUrlButton, EditButton, IndigoButton, MultipurposeOvalButton, OpenUrlButton, TealButton, TrashButton } from "@/components/Atoms/Buttons/ColorButtons";
import ReactMarkdownMod from "@/components/Atoms/ReactMarkdownMod";
import TagPill_1 from "@/components/Atoms/Tags/TagPill_1";
import AvatarImage from "@/components/Molecules/AvatarImage";
import { dateFormat_2, dateFormat_3, dateFormat_4 } from "@/utils/frontend/dateOps";
import getTagDevIconName from "@/utils/frontend/getTagDevIconName";
import { formatSocialPostBody, formatString, getEntityLocationStr, humanizeString } from "@/utils/frontend/stringOps";
import Link from "next/link";
import { useRef, useState } from "react";
import ReactMarkdown from 'react-markdown';
import { useRouter, useSearchParams } from 'next/navigation'
import BorderedFrameBox from "@/components/Molecules/BorderedFrameBox";
import TagPill_3 from "@/components/Atoms/Tags/TagPill_3";
import ReactMarkdownMod_2 from "@/components/Atoms/ReactMarkdownMod_2";
import BusinessCard from "../BusinessCard";
import getBaseUrl from "@/utils/shared/getBaseUrl";
import TableOfContents from "@/components/Molecules/TableOfContents";
const SocialPostSmallCard = ({ 
  data, 
  callback, 
  state, 
  lang, 
  user, 
  parentComponent, // INDEX, THREAD, PAGE (social/[post]/page.js)
  parentModule, // JOBS, TALENTS
  isNestedComment, 
  replyToUUID,
  cardIsClickable=true
 }) => {
  // console.log("DATA@SocialPostSmallCard", data)

    const cardIsComment = Boolean(data.social_post_comment_uuid)

  //   console.log("USER@SocialPostSmallCard", user)
  // console.log('data@socialpostsmallcard', data)
// console.log(data.parent_social_post_comment_uuid, data.social_post_comment_body)
  const router = useRouter()
  const searchParams = useSearchParams()
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [deleteConfirmation, setDeleteConfirmation] = useState(0)
  const [rootDeleteConfirmation, setRootDeleteConfirmation] = useState(0)
  const [showBusinessCard, setShowBusinessCard] = useState(false)

  // console.log("DATA@SocialPostSmallCard.js", data)
  // console.log("DATA@JobBigCard.js", data)
  // let data = selectedData ? selectedData : initialData 

  /*=====================================================
  --- HELPER FUNCTIONS START
  ======================================================*/
  const getRecordData = (parentModule) => {

    let moduleName, uuid, url;

    if (parentModule === 'TALENTS') { 
      moduleName = 'talent'
      uuid = data.talent_uuid
      url = data.talent_url
    }
    else if (parentModule === 'JOBS') {
      moduleName = 'jobs'
      uuid = data.job_uuid
      url = data.job_url
    }

    return {module:moduleName, uuid:uuid, url:url};
    
  }

  const renderData = () => {
  
  let firstName =data.user_data.user_first_name
  let lastName = data.user_data.user_last_name


  let fullName, handle, postBody, postTitle;

  if (data.is_anonymous === true) {
    fullName = 'Anonymous'
    handle = null
    postBody = data.social_post_body || data.social_post_comment_body
    postTitle = data.social_post_title
  }

  else if (data.status === 'ACTIVE') {
    if (data.user_data.actor_type === 'USER'){
      fullName = firstName + (lastName ? ' ' + lastName : '')
      handle = data.user_data.user_handle
    }
    else if (data.user_data.actor_type === 'ORGANIZATION'){
      fullName = data.user_data.organization_name
      handle = data.user_data.organization_handle
    }
    postBody = data.social_post_body || data.social_post_comment_body
    postTitle = data.social_post_title
  }
  else if (data.status === 'ARCHIVED') {
    fullName = 'Deleted'
    handle = 'Deleted'
    postBody = '[ Deleted ]'
    postTitle = 'Deleted'
  }
  else if (data.status === 'PENDING_REVIEW' || data.status === 'DRAFT'){
    if (user?.user_roles?.role === 'ROOT' || user?.user_roles?.role === 'MODERATOR'){
        if (data.user_data.actor_type === 'USER'){
          fullName = firstName + (lastName ? ' ' + lastName : '') + ' '
          handle = data.user_data.user_handle
        }
        else if (data.user_data.actor_type === 'ORGANIZATION'){
          fullName = data.user_data.organization_name + ' '
          handle = data.user_data.organization_handle
        }
        postBody = "** " + data.status + " **\n(only you can see this)\n\n" + data.social_post_body || data.social_post_comment_body
        postTitle = data.social_post_title
    }
    else {
      return null;
    }
  }

  const postBodyAbbreviated = postBody?.length > 500 ? postBody.substring(0,500) + '...' : postBody
  return {fullName: fullName, handle: handle, postBody: {abbreviated: postBodyAbbreviated, full: postBody}, postTitle: postTitle}
  }

  const avatarNameHoverTimeoutRef = useRef(null);

  const handleAvatarNameMouseEnter = (userHandle) => {
    clearTimeout(avatarNameHoverTimeoutRef.current);
    // setShowBusinessCard(data.user_data.user_handle);
    setShowBusinessCard(userHandle)
  };

  const handleAvatarNameMouseLeave = () => {
    avatarNameHoverTimeoutRef.current = setTimeout(() => {
      setShowBusinessCard(null);
    }, 200);
  };


  /*=====================================================
  --- HELPER FUNCTIONS END
  ======================================================*/




  /*=====================================================
  --- ACTION FUNCTIONS START
  ======================================================*/
  //callback from TasksSplitViewCard.js 
  // handleSubmit from Task Status Button
  const handleChildCallback= async (cback)=> {
      
  }   

  // console.log("DATA@JobBigCard", data)

  const handleEditSubmit = (element) =>{

      const putData = {
          id: data?.task_data.id,
          task_title: editedData?.task_title || data?.task_data.task_title,
          task_type: editedData?.task_type || data?.task_data.task_type,
          task_due_date: editedData?.task_due_date || data?.task_data.task_due_date,
          task_content: editedData?.task_content || data?.task_data.task_content,
          task_status: editedData?.task_status || data?.task_data.task_status
      }

    
      callback({action: 'taskUpdate', putData: putData})
  }


  const handleDelete = async (e) => {
      e.stopPropagation()
    if (deleteConfirmation === 0) {
      setDeleteConfirmation(1)
      return false;
    }
    try {
    //    ?id=${target.id}
    let apiUrl;
    if (parentComponent === 'THREAD') { // in post thread - deleting comment
      apiUrl = `/api/social/comments/${data.social_post_comment_uuid}?user_type=${user.user_type}`
    }
    else { // in all posts (social) - deleting post
      apiUrl = `/api/social/posts/${data.social_post_uuid}?user_type=${user.user_type}`
    }

          let response = await fetch(apiUrl, {
          method: 'PUT', // if deleting comment, PUT, if deleting post, PUT as well
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
            body: JSON.stringify({data: {
            status: 'ARCHIVED',
            notification_recipient_user_uuid: data.social_post_user_uuid ? data.social_post_user_uuid : data.social_post_comment_user_uuid // either comment's or post's owner uuid, depending on what we're liking
          }, user: user})
          // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        console.log('handleDeleteResponse', response)
      if (response.success === true ) {
        setSuccess({message: 'The post has been deleted.'})
        router.refresh()
    //    setLoading(false)
      }
      else { 
        setError({message: 'There was a problem deleting this post.'})
    //    setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
          // setLoading(false)
        }
  }

  const handleRootDelete = async (e) => {
      e.stopPropagation()
    if (rootDeleteConfirmation === 0) {
      setRootDeleteConfirmation(1)
      return false;
    }
     try {
     //    ?id=${target.id}
     let apiUrl;
     if (parentComponent === 'THREAD') { // in post thread - deleting comment
      apiUrl = `/api/social/comments/${data.social_post_comment_uuid}?user_type=${user.user_type}`
     }
     else { // in all posts (social) - deleting post
      apiUrl = `/api/social/posts/${data.social_post_uuid}?user_type=${user.user_type}`
     }

          let response = await fetch(apiUrl, {
          method: 'DELETE', // if deleting comment, PUT, if deleting post, PUT as well
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        console.log('handleDeleteResponse', response)
      if (response.success === true ) {
        setSuccess({message: 'The post has been deleted.'})
        router.refresh()
     //    setLoading(false)
      }
      else { 
        setError({message: 'There was a problem deleting this post.'})
     //    setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
          // setLoading(false)
        }
  }


  const handleRootStatusChange = async (e, statusArg) => {
      e.stopPropagation()
      // e.preventDefault()

     try {
     //    ?id=${target.id}
     let apiUrl;
     if (parentComponent === 'THREAD') { // in post thread - deleting comment
      apiUrl = `/api/social/comments/${data.social_post_comment_uuid}?user_type=${user.user_type}`
     }
     else { // in all posts (social) - deleting post
      apiUrl = `/api/social/posts/${data.social_post_uuid}?user_type=${user.user_type}`
     }

          let response = await fetch(apiUrl, {
          method: 'PUT', // if deleting comment, PUT, if deleting post, PUT as well
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          body: JSON.stringify({data: {
            status: statusArg,
            notification_recipient_user_uuid: data.social_post_user_uuid ? data.social_post_user_uuid : data.social_post_comment_user_uuid // either comment's or post's owner uuid, depending on what we're liking
          }, user: user})
          // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        console.log('handleRootStatusChange', response)
      if (response.success === true ) {
        setSuccess({message: `The status has been changed to ${statusArg}`})
        router.refresh()
     //    setLoading(false)
      }
      else { 
        setError({message: 'There was a problem changing the status of this post.'})
     //    setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
          // setLoading(false)
        }
  }


  const handlePostUpvote = async (e) => {
    e.stopPropagation()
    if (!user) {
      setError({message: 'Please sign in'})
    }
     try {
     //    ?id=${target.id}
    //  let apiUrl = `/api/social/reactions/${data.social_post_uuid}?user_type=${user.user_type}`
      let apiUrl;
      if (data.social_post_uuid){ // the card is a top level social post
        apiUrl = `/api/social/reactions/?user_type=${user.user_type}&record_type=POST`
      } 
      else if (data.social_post_comment_uuid){
        apiUrl = `/api/social/reactions/?user_type=${user.user_type}&record_type=COMMENT`
      }
          // let apiUrl = `/api/social/reactions?user_type=${user.user_type}`


          let response = await fetch(apiUrl, {
          method: 'POST', // if deleting comment, PUT, if deleting post, PUT as well
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          body: JSON.stringify({data: {
            record_data: data,
            reaction_type: 'UPVOTE', 
            reaction_target_type: data.social_post_uuid ? 'SOCIAL_POST' : 'SOCIAL_COMMENT',
            reaction_target_uuid: data.social_post_uuid ? data.social_post_uuid : data.social_post_comment_uuid,
            notification_recipient_user_uuid: data.social_post_user_uuid ? data.social_post_user_uuid : data.social_post_comment_user_uuid // either comment's or post's owner uuid, depending on what we're liking
          }, user: user}), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        console.log('handleUpvoteResponse', response)
      if (response.success === true ) {
        // setSuccess({message: 'The post has been upvoted.'})
        router.refresh()
     //    setLoading(false)
      }
      else { 
        setError({message: `There was a problem upvoting this post. Error: ${response.error}`})
     //    setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
          // setLoading(false)
        }
  }


  const handleDeleteUpvote = async (e) => {
    
    e.stopPropagation()
        try {
      //    ?id=${target.id}
      let apiUrl;
      if (data.social_post_uuid){ // the card is a top level social post
        apiUrl = `/api/social/reactions/${data.social_post_uuid}?user_type=${user.user_type}&record_type=POST`
      } 
      else if (data.social_post_comment_uuid){
        apiUrl = `/api/social/reactions/${data.social_post_comment_uuid}?user_type=${user.user_type}&record_type=COMMENT`
      }

      // if (parentComponent === 'THREAD') { // in post thread - deleting comment
      //   apiUrl = `/api/social/reactions/${data.social_post_comment_uuid || data.social_post_uuid}?user_type=${user.user_type}&record_type=COMMENT`
      // }
      // else { // in all posts (social) - deleting post
      //   apiUrl = `/api/social/reactions/${data.social_post_comment_uuid || data.social_post_uuid}?user_type=${user.user_type}&record_type=POST`
      // }

            let response = await fetch(apiUrl, {
            method: 'DELETE', // if deleting comment, PUT, if deleting post, PUT as well
            headers: {
              'Accept': '*/*',
              'Content-Type': 'application/json'
            },
            credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
            // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
            // body: data
          });

          response = await response.json()
          console.log('handleDeleteResponse', response)
        if (response.success === true ) {
          // setSuccess({message: 'The post has been deleted.'})
          router.refresh()
      //    setLoading(false)
        }
        else { 
        setError({message: `There was a problem upvoting this post. Error: ${response.error.message}`})
      //    setLoading(false)
        }
        // callback({refreshData: true})

              
          } catch (error) {
            console.log('error', error)
            // setLoading(false)
          }
  }


  const handleRespond = async (e) => {
    // if we hit the comment button either on a page or in a thread, it'll focus on text area,
    // if however we hit the comment button in /social/page.js, it won't.
    (parentComponent === 'THREAD' || parentComponent === 'PAGE') && callback({focusOnTextArea: true})
    // e.preventDefault()
      // e.stopPropagation()
    if (parentComponent === 'THREAD'){ // in root comment thread, this becomes a reply to a comment
        // router.push(`?thread=${searchParams.get('thread')}&reply-to-uuid=${data.social_post_comment_uuid}&reply-to-handle=${data.user_data.user_handle}`, undefined, {shallow:true, scroll:false})
        router.push(`?thread=${searchParams.get('thread')}&reply-to-uuid=${data.social_post_comment_uuid}`, undefined, {shallow:true, scroll:false})
    }
    else if (parentComponent === 'PAGE'){ // from /social/[post]/page.js
      // router.push(`?reply-to-uuid=${data.social_post_comment_uuid}&reply-to-handle=${data.user_data.user_handle}#${data.social_post_comment_uuid}`, undefined, {shallow:true, scroll:false})
      router.push(`?reply-to-uuid=${data.social_post_comment_uuid}#${data.social_post_comment_uuid}`, undefined, {shallow:true, scroll:false})
    }
    else if (parentComponent === 'INDEX') { // in all posts, this becomes a root comment to a post (we're attaching social/ to searchParams)
      router.push(`feed?thread=${data.social_post_uuid}`, undefined, {shallow:true, scroll:false})
    }
    // else if (parentComponent === 'PAGE') { // from social/[post]/page.js
    //   router.push(`?reply-to-uuid=${data.social_post_comment_uuid}&reply-to-handle=${data.user_data.user_handle}#${data.social_post_comment_uuid}`, undefined, {shallow:true, scroll:false})
    // }
    else { // in all posts, this becomes a root comment to a post
      // reply-to-user-uuid=${data.social_post_comment_user_uuid // used for notifications
      router.push(`?thread=${data.social_post_uuid}#${data.social_post_uuid}`, undefined, {shallow:true, scroll:false})
      // #data.socialpostuuid prevents page from jumping up here
    }
  }


  const handleChange = (field, value) => {
    //    setEditedData({
    //        ...editedData,
    //        [field]: value
    //        // [event.target.name]: event.target.value,
    //    });
    //    console.log(editedData);
  };

  // function countComments(comments = []) {
  //   let count = 0;

  //   for (const comment of comments) {
  //     count += 1; // count this comment

  //     if (comment.replies && comment.replies.length > 0) {
  //       count += countComments(comment.replies); // recurse
  //     }
  //   }

  //   return count;
  // }
  function countComments(comments = []) {
      let count = 0;

      for (const comment of comments) {
          count += 1; // count this comment

          if (comment.replies && comment.replies.length > 0) {
          count += countComments(comment.replies); // recurse
          }
      }

      return count;
  }



  /*=====================================================
  --- ACTION FUNCTIONS END
  ======================================================*/

const rd = renderData()
if (!rd) { return null; }

// console.log("data@SocialPostSmallCard", data)
// console.log("replyToUUID", replyToUUID, data.social_post_comment_uuid, data.social_post_comment_body)

  // if the post doesn't have thE ACTIVE or ARCHIVED status, hide it (example PENDING_REVIEW) and the user isn't root
  return (

 <div onClick={e=>{cardIsClickable === true ? handleRespond(e) : ()=>{}}} id={data.social_post_uuid || data.social_post_comment_uuid} className={`
  ${(parentComponent === 'THREAD' || parentComponent==='PAGE') ? 'bg-slate-50 dark:bg-slate-900' : ' cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700'} 
  ${isNestedComment && 'border-l'} 
  ${(replyToUUID && replyToUUID === data.social_post_comment_uuid) && 'dark:bg-slate-950 bg-slate-100 border-l-2 border-l-teal-400 dark:border-l-teal-400'} 
  w-full border-b border-slate-200 dark:border-slate-700 px-4 py-6 transition duration-150 text-base font-inter`}>
      <Alert state={{success: success, setSuccess: setSuccess, error: error, setError: setError}} message={success ? success.message : error ? error.message : ''}/>

      {/* Header: Avatar + Name + Timestamp */}
      <div className="flex items-start gap-3">
        {/* avatar */}
        {data.status === 'ACTIVE' && data.is_anonymous === false
        ? 
        <div className="relative" onMouseLeave={()=>{handleAvatarNameMouseLeave()}} onMouseEnter={()=>{handleAvatarNameMouseEnter(data.user_data.user_handle)}} onClick={e=>e.stopPropagation()} href={`/@${data.user_data.user_handle}`}>
          <AvatarImage isAnonymous={data.is_anonymous} data={data.user_data} module="USER" size={parentComponent==='THREAD' ? 'xs' : 'sm'} hoverable={true} />
          {showBusinessCard === data.user_data.user_handle &&   
            <div className="absolute left-0 top-full z-[100] mt-2 bg-slate-50 dark:bg-slate-900 p-4 w-48 rounded-lg">    
 
            <BusinessCard 
              showFollowButton={data.status !== 'ARCHIVED' && data.user_data.user_handle?.toUpperCase()!=='DELETED' && data.user_data.user_handle!==null && data.user_data.user_handle!=='null'} 
              recordType={data.user_data.actor_type} // can be ORGANIZATION or USER
              showUserSectorIndustry={true} 
              userFullNameTextSize={'text-md'} 
              showUserUrls={false} 
              key={data.user_data.user_uuid} 
              avatarSize={'md'} 
              user={user} 
              baseUrl={getBaseUrl()} 
              data={data.user_data} 
              lang='en' 
              avatarIsClickable={data.status !== 'ARCHIVED' && data.user_data.user_handle?.toUpperCase()!=='DELETED' && data.user_data.user_handle!==null && data.user_data.user_handle!=='null'} 
              nameIsClickable={data.status !== 'ARCHIVED' && data.user_data.user_handle?.toUpperCase()!=='DELETED' && data.user_data.user_handle!==null && data.user_data.user_handle!=='null'} 
              userLocationLabelSize="text-xs"/>

            </div>
          }

        </div> 
        :
          data.is_anonymous ? 
           <AvatarImage isAnonymous={data.is_anonymous} data={data.user_data} module="USER" size={parentComponent==='THREAD' ? 'xs' : 'sm'} hoverable={true} />
           :
        <AvatarImage isDeleted={data.status === 'ARCHIVED'} data={data.user_data} module="USER" size={parentComponent==='THREAD' ? 'xs' : 'sm'} hoverable={false} />
        }

        {/* name */}
        <div className="flex flex-col w-full">
          <div className="flex items-start gap-2 leading-none">

              <div className="flex flex-col gap-1">
              <Link onClick={e=>e.stopPropagation()} href={data.is_anonymous === false ? `/@${renderData().handle}` : '#'}>
                <span className={`hover:underline cursor-pointer dark:text-white font-ubuntu`}>
                  {renderData().fullName}<br/>
                </span>
                </Link>
                <div className="flex flex-row gap-1">
                  <Link onClick={e=>e.stopPropagation()} href={data.is_anonymous === false ? `/@${renderData().handle}` : '#'}>
                <span className="flex items-center text-xs text-slate-400">@{renderData().handle}</span>
                </Link>
                <span className="flex items-center text-slate-300  text-xs" aria-hidden="true">⋅</span>
                 <span className="flex items-center text-xs text-slate-400">{dateFormat_2(data.published_date || data.created_date)}</span>
                  {/* <span className="flex items-center text-slate-300  text-xs" aria-hidden="true">⋅</span>
                  <span className="flex items-center text-xs text-slate-400">{dateFormat_4(data.created_date)}</span> */}
                 </div>

              </div>
              {/* :
              data.is_anonymous ?
              <div className="flex flex-col gap-1">
                <span className={`dark:text-white font-ubuntu`}>
                Anonymous
                </span>
                <span className="text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
               </div>
               :
              <div className="flex flex-col gap-1">
              <span className={`dark:text-white font-ubuntu`}>
              Deleted
              </span>
               <span className="text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
               </div>
            } */}









            {/* {data.status === 'ACTIVE' && data.is_anonymous === false
              ? 
              <div className="flex flex-col gap-1">
              <Link onClick={e=>e.stopPropagation()} href={`/@${data.user_data.user_handle}`}>
                <span className={`hover:underline cursor-pointer dark:text-white font-ubuntu`}>
                  {data.user_data.user_first_name} {data.user_data.user_last_name}<br/>
                </span>
                </Link>
                <div className="flex flex-row gap-1">
                  <Link onClick={e=>e.stopPropagation()} href={`/@${data.user_data.user_handle}`}>
                <span className="flex items-center text-xs text-slate-400">@{data.user_data.user_handle}</span>
                </Link>
                <span className="flex items-center text-slate-300  text-xs" aria-hidden="true">⋅</span>
                 <span className="flex items-center text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
                 </div>

              </div>
              :
              data.is_anonymous ?
              <div className="flex flex-col gap-1">
                <span className={`dark:text-white font-ubuntu`}>
                Anonymous
                </span>
                <span className="text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
               </div>
               :
              <div className="flex flex-col gap-1">
              <span className={`dark:text-white font-ubuntu`}>
              Deleted
              </span>
               <span className="text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
               </div>
            } */}

           
          </div>
          
          {/* post body + image(s) */}
          <div className="my-2">
            {/* {parentComponent==='THREAD' 
              ? // if post is timeless, render markdown, else render formatted.
              formatSocialPostBody(renderData().postBody)
              : 
             formatSocialPostBody (renderData().postBody)
            } */}

            {/* if it's timeless, render markdown, else, render formatted.
              if it's in thread or in page, render full, if it's in feed, render abbreviated
            */}

            {data.is_timeless ? 
            <div className="prose prose-lg break-word overflow-x-auto max-w-none h-full overflow-y-auto dark:prose-invert">
              {/* <ReactMarkdownMod components={{
                  a: ({ node, ...props }) => (
                    <a
                      {...props}
                      onClick={(e) => e.stopPropagation()} // stops card click
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-teal-500 hover:underline"
                    />
                  ),
                }}> */}
                 {/* {renderData().postTitle} */}
                <h2>{data.social_post_title}</h2>
                <ReactMarkdownMod_2>
                  {(parentComponent ==='THREAD' || parentComponent === 'PAGE') ? renderData().postBody.full : renderData().postBody.abbreviated
              }</ReactMarkdownMod_2>

              {/* <div className="fixed right-4 top-1/2 -translate-y-1/2 z-40">
                <TableOfContents />
              </div> */}

            </div>
            :
              <div className="mt-1 text-sm font-normal break-word text-slate-800 dark:text-gray-300 whitespace-pre-wrap">
                <p>
                  {
                    (parentComponent ==='THREAD' || parentComponent === 'PAGE') ?
                      formatSocialPostBody (renderData().postBody.full) : formatSocialPostBody (renderData().postBody.abbreviated)
                  }
                </p>
             </div>
          }

            {/* Post body */}
            {/* <div className="mt-1 text-sm font-normal text-slate-800 dark:text-gray-300 whitespace-pre-wrap">
              {
              data.status === 'ACTIVE' 
              ?
              (parentComponent==='THREAD' ? formatSocialPostBody(data.social_post_comment_body) : formatSocialPostBody (data.social_post_body))
              :
              '[ Deleted ]'
              }
              
            </div> */}

            {/* post topics */}
            {/* {data.topics && <div className="mt-6 text-sm text-slate-800 dark:text-gray-300 whitespace-pre-wrap flex gap-1">
              {data.topics.map(t => <TagPill_3 key={t.uuid} href={`/feed?topic=${t.topic_name_en}`} caption={t.topic_name_en}/>)}
              </div>
              } */}
              {data.topics && (
  <div className="mt-6 text-sm text-slate-800 dark:text-gray-300 flex flex-wrap gap-1">
    {data.topics.map(t => (
      <TagPill_3
        key={t.uuid}
        href={`/feed?topic=${t.topic_name_en}`}
        caption={t.topic_name_en}
      />
    ))}
  </div>
)}
            {/* Post image(s) */}
            {data.files && <div className="my-4 text-sm text-slate-800 dark:text-gray-300 whitespace-pre-wrap">
              {data.files?.map(f => {
                  return <img 
                    className={'rounded-lg max-h-[500px]'}
                    key={f.file_uuid}
                    // src={`/assets/social/post_${parentComponent === 'THREAD' ? data.social_post_comment_uuid : data.social_post_uuid}/${f.file_name}`}
                    src={`/assets/social/post_${data.social_post_uuid}/${f.file_name}`}
                    />
              })}

            </div>}
          </div>

          {/* Optional tags or location */}
          {data.entity_location && (
            <div className="mt-2 text-xs text-slate-500 dark:text-slate-400">
              {data.entity_location}
            </div>
          )}






 {/* {user.user_is_root && 
 <div className="mt-8">
        <BorderedFrameBox
        bgColor={'dark:bg-slate-800'}
                  borderColor="border-teal-400"
                    title={'ROOT'} 
                    body={  <TrashButton disabled={false} caption={'ROOT DELETE'} onClick={handleRootDelete} deleteConfirmation={rootDeleteConfirmation}/>}
                    />
        </div>
      } */}









 
 {/* ADMIN / MOD SECTION */}
           {
     user?.user_roles.role === 'ROOT' && 
      <div className="mt-2 flex gap-2 text-xs text-slate-500 dark:text-slate-400">
    <div className="flex gap-1 items-center rounded-2xl">
      

      {/* <select id="status_change" name="status_change" className="py-4 px-4 rounded-lg bg-slate-100 dark:bg-slate-800" defaultValue={''}>
  <option value="" disabled> Status: {humanizeString(data.status)}</option>    
  <option onClick={(e)=>{handleRootStatusChange(e, 'PENDING_REVIEW');}} value="PENDING_REVIEW">PENDING_REVIEW</option>
    <option onClick={(e)=>{handleRootStatusChange(e, 'ACTIVE')}} value="ACTIVE">ACTIVE</option>
    <option onClick={(e)=>{handleRootStatusChange(e, 'FLAGGED')}} value="FLAGGED">FLAGGED</option>
    <option onClick={(e)=>{handleRootStatusChange(e, 'REJECTED')}} value="REJECTED">REJECTED</option>
    <option onClick={(e)=>{handleRootStatusChange(e, 'ARCHIVED')}} value="ARCHIVED">ARCHIVED</option>
  </select> */}


                <select
                id="status_change"
                name="status_change"
                className="py-4 px-4 rounded-lg bg-slate-100 dark:bg-slate-800"
                value={data.status || ''}
                onChange={(e) => {
                  handleRootStatusChange(e, e.target.value)
                  // setData({
                  //   ...data,
                  //   status: e.target.value
                  // });
                }}
              >
                <option value="" disabled>
                  Status: {humanizeString(data.status)}
                </option>

                <option value="PENDING_REVIEW">PENDING_REVIEW</option>
                <option value="DRAFT">DRAFT</option>
                <option value="ACTIVE">ACTIVE</option>
                <option value="INACTIVE">INACTIVE</option>
                <option value="FLAGGED">FLAGGED</option>
                <option value="REJECTED">REJECTED</option>
                <option value="ARCHIVED">ARCHIVED</option>
              </select>


        {/* <ConfirmOrCancelButton caption={'Approve Post'} disabled={false} onClick={e=>handleRootDelete(e)} deleteConfirmation={rootDeleteConfirmation}/> */}

    <ArrowUpButton disabled={data.status === 'ARCHIVED'} onClick={e=>handlePostUpvote(e)} caption={data.reactions_count} reacted={data.reacted_by_me}/>
            <TrashButton disabled={false} onClick={e=>handleRootDelete(e)} deleteConfirmation={rootDeleteConfirmation}/>
    </div>
    </div>
    }




  <div className="mt-2 flex gap-2 text-xs text-slate-500 dark:text-slate-400">


    


{
  /* -------------------------------
    if user is root 
    AND 
    if post doesn't belong to user AND location is not post thread
    AND
    post / comment is not deleted
  ---------------------------------*/
  
  //   (user?.user_is_root === true || 
  //   (user?.user_uuid === data.social_post_actor_uuid && parentComponent !== 'THREAD') 
  // ) && data.is_archived === false 
  data.status === 'ACTIVE' || data.status === 'DRAFT'
  ? (
  <>

    <div className="flex flex-row w-full justify-between">
  {/* if user is owner of comment or post, show trash and edit button */}
  <div className="flex flex-row gap-1">
   <ArrowUpButton disabled={data.status === 'ARCHIVED'} onClick={e=>data.reacted_by_me ? handleDeleteUpvote(e) : handlePostUpvote(e)} caption={data.reactions_count} reacted={data.reacted_by_me}/>
   <CommentButton disabled={false} onClick={e=>handleRespond(e)} caption={data.comments_count || data.replies?.length || 0}/>



    {cardIsComment === false && <CopyUrlButton disabled={data.status === 'ARCHIVED'} 
      onClick={e=>{
      navigator.clipboard.writeText(`https://talnet.co/posts/${data.is_timeless ? data.social_post_url : data.social_post_url_short}`); e.stopPropagation(); setSuccess({message: 'Post url copied'})}} reacted={data.reacted_by_me}/>
      }

    {/* <MultipurposeOvalButton onClick={e=>{e.stopPropagation();callback({setShareModalOpen:true, post:data})}} purpose={'share'}/> */}

    {parentComponent !== 'THREAD' && parentComponent !== 'PAGE' && <OpenUrlButton onClick={(e)=>e.stopPropagation()} disabled={false} url={`/posts/${
      data.is_timeless ? data.social_post_url : data.social_post_url_short}`}/>}
  {data.social_post_url_short && 
  // for the time being, we can only copy urls to posts, not post comments
  <>
    {/* <CopyUrlButton disabled={data.status === 'ARCHIVED'} 
    onClick={e=>{
    navigator.clipboard.writeText('https://talnet.co/feed/' + data.social_post_url_short); e.stopPropagation(); setSuccess({message: 'Post url copied'})}} reacted={data.reacted_by_me}/>
    <OpenUrlButton onClick={(e)=>e.stopPropagation()} disabled={false} url={`/feed/${data.social_post_url_short}`}/> */}
      </>
    }

               {/* <MultipurposeOvalButton onClick={(e)=>{e.stopPropagation();state.setShareModalOpen(true)}} purpose={'share'}/> */}
      </div>
      
      <div>
    {
    ( data.social_post_user_uuid ? user?.user_uuid === data.social_post_user_uuid : user?.user_uuid === data.social_post_comment_user_uuid)
      
      &&
      <div className="flex gap-1">
      {cardIsComment === false && <EditButton disabled={false} onClick={(e)=>{e.stopPropagation();router.push(`/posts/${
      data.is_timeless ? data.social_post_url : data.social_post_url_short}?editing=true`)}} active={false}/>}
      <TrashButton disabled={data.status === 'ARCHIVED'} onClick={e=>handleDelete(e)} deleteConfirmation={deleteConfirmation}/>
        </div>
  }
  </div>
  </div>
   </>
   )

  /*-----------------------------------
    available to everyone (no sign in needed)
  -------------------------------------*/
     : parentComponent !== 'THREAD' &&  
    (   <>
      <ArrowUpButton disabled={data.status === 'ARCHIVED'} onClick={e=>data.reacted_by_me ? handleDeleteUpvote(e) : handlePostUpvote(e)} caption={data.reactions_count} reacted={data.reacted_by_me}/>
    <CommentButton disabled={false} onClick={e=>handleRespond(e)} caption={data.comments_count || data.replies?.length || 0}/>

      <CopyUrlButton disabled={data.status === 'ARCHIVED'} 
    onClick={e=>{
    navigator.clipboard.writeText(`https://talnet.co/posts/${data.is_timeless ? data.social_post_url : data.social_post_url_short}`); e.stopPropagation(); setSuccess({message: 'Post url copied'})}} reacted={data.reacted_by_me}/>
    <OpenUrlButton onClick={(e)=>e.stopPropagation()} disabled={false} url={`/posts/${  data.is_timeless ? data.social_post_url : data.social_post_url_short}`}/>
  </>
)
}
    </div>     
          {/* maybe reactions bar? */}
          {/* <div className="mt-2 flex gap-6 text-xs text-slate-500 dark:text-slate-400">
            <span></span>
            <span></span>
            <span></span>
          </div> */}
        </div>
      </div>
    </div>



  );

};

export default SocialPostSmallCard;






































// "use client"
// import Alert from "@/components/Atoms/Alerts/Alert";
// import { ArrowUpButton, CommentButton, CopyUrlButton, IndigoButton, TealButton, TrashButton } from "@/components/Atoms/Buttons/ColorButtons";
// import ReactMarkdownMod from "@/components/Atoms/ReactMarkdownMod";
// import TagPill_1 from "@/components/Atoms/Tags/TagPill_1";
// import AvatarImage from "@/components/Molecules/AvatarImage";
// import { dateFormat_2, dateFormat_3 } from "@/utils/frontend/dateOps";
// import getTagDevIconName from "@/utils/frontend/getTagDevIconName";
// import { formatSocialPostBody, formatString, getEntityLocationStr, humanizeString } from "@/utils/frontend/stringOps";
// import Link from "next/link";
// import { useState } from "react";
// import ReactMarkdown from 'react-markdown';
// import { useRouter, useSearchParams } from 'next/navigation'
// import BorderedFrameBox from "@/components/Molecules/BorderedFrameBox";
// import TagPill_3 from "@/components/Atoms/Tags/TagPill_3";
// const SocialPostSmallCard = ({ 
//   data, 
//   callback, 
//   state, 
//   lang, 
//   user, 
//   parentComponent, // INDEX, THREAD, PAGE (social/[post]/page.js)
//   isNestedComment, 
//   replyToUUID }) => {

//   // console.log('data@socialpostsmallcard', data)
// // console.log(data.parent_social_post_comment_uuid, data.social_post_comment_body)
//   const router = useRouter()
//   const searchParams = useSearchParams()
//   const [success, setSuccess] = useState(false)
//   const [error, setError] = useState(false)
//   const [deleteConfirmation, setDeleteConfirmation] = useState(0)
//   const [rootDeleteConfirmation, setRootDeleteConfirmation] = useState(0)
//   // console.log("DATA@SocialPostSmallCard.js", data)
//   // console.log("DATA@JobBigCard.js", data)
//   // let data = selectedData ? selectedData : initialData 



//     //callback from TasksSplitViewCard.js 
//     // handleSubmit from Task Status Button
//     const handleChildCallback= async (cback)=> {
       
//     }   

//     // console.log("DATA@JobBigCard", data)

//     const handleEditSubmit = (element) =>{

//         const putData = {
//             id: data?.task_data.id,
//             task_title: editedData?.task_title || data?.task_data.task_title,
//             task_type: editedData?.task_type || data?.task_data.task_type,
//             task_due_date: editedData?.task_due_date || data?.task_data.task_due_date,
//             task_content: editedData?.task_content || data?.task_data.task_content,
//             task_status: editedData?.task_status || data?.task_data.task_status
//         }

     
//         callback({action: 'taskUpdate', putData: putData})
//     }

//   const handleDelete = async (e) => {
//       e.stopPropagation()
//     if (deleteConfirmation === 0) {
//       setDeleteConfirmation(1)
//       return false;
//     }
//      try {
//      //    ?id=${target.id}
//      let apiUrl;
//      if (parentComponent === 'THREAD') { // in post thread - deleting comment
//       apiUrl = `/api/social/comments/${data.social_post_comment_uuid}?user_type=${user.user_type}`
//      }
//      else { // in all posts (social) - deleting post
//       apiUrl = `/api/social/posts/${data.social_post_uuid}?user_type=${user.user_type}`
//      }

//           let response = await fetch(apiUrl, {
//           method: 'PUT', // if deleting comment, PUT, if deleting post, PUT as well
//           headers: {
//             'Accept': '*/*',
//             'Content-Type': 'application/json'
//           },
//           credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
//           // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
//           // body: data
//         });

//         response = await response.json()
//         console.log('handleDeleteResponse', response)
//       if (response.success === true ) {
//         setSuccess({message: 'The post has been deleted.'})
//         router.refresh()
//      //    setLoading(false)
//       }
//       else { 
//         setError({message: 'There was a problem deleting this post.'})
//      //    setLoading(false)
//       }
//       // callback({refreshData: true})

            
//         } catch (error) {
//           console.log('error', error)
//           // setLoading(false)
//         }
// }

//   const handleRootDelete = async (e) => {
//       e.stopPropagation()
//     if (rootDeleteConfirmation === 0) {
//       setRootDeleteConfirmation(1)
//       return false;
//     }
//      try {
//      //    ?id=${target.id}
//      let apiUrl;
//      if (parentComponent === 'THREAD') { // in post thread - deleting comment
//       apiUrl = `/api/social/comments/${data.social_post_comment_uuid}?user_type=${user.user_type}`
//      }
//      else { // in all posts (social) - deleting post
//       apiUrl = `/api/social/posts/${data.social_post_uuid}?user_type=${user.user_type}`
//      }

//           let response = await fetch(apiUrl, {
//           method: 'DELETE', // if deleting comment, PUT, if deleting post, PUT as well
//           headers: {
//             'Accept': '*/*',
//             'Content-Type': 'application/json'
//           },
//           credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
//           // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
//           // body: data
//         });

//         response = await response.json()
//         console.log('handleDeleteResponse', response)
//       if (response.success === true ) {
//         setSuccess({message: 'The post has been deleted.'})
//         router.refresh()
//      //    setLoading(false)
//       }
//       else { 
//         setError({message: 'There was a problem deleting this post.'})
//      //    setLoading(false)
//       }
//       // callback({refreshData: true})

            
//         } catch (error) {
//           console.log('error', error)
//           // setLoading(false)
//         }
// }

//   const handlePostUpvote = async (e) => {
//     e.stopPropagation()
//     if (!user) {
//       setError({message: 'Please sign in'})
//     }
//      try {
//      //    ?id=${target.id}
//     //  let apiUrl = `/api/social/reactions/${data.social_post_uuid}?user_type=${user.user_type}`
//           let apiUrl = `/api/social/reactions?user_type=${user.user_type}`


//           let response = await fetch(apiUrl, {
//           method: 'POST', // if deleting comment, PUT, if deleting post, PUT as well
//           headers: {
//             'Accept': '*/*',
//             'Content-Type': 'application/json'
//           },
//           credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
//           body: JSON.stringify({data: {
//             reaction_type: 'UPVOTE', 
//             reaction_target_type: data.social_post_uuid ? 'SOCIAL_POST' : 'SOCIAL_COMMENT',
//             reaction_target_uuid: data.social_post_uuid ? data.social_post_uuid : data.social_post_comment_uuid,
//             notification_recipient_user_uuid: data.social_post_user_uuid ? data.social_post_user_uuid : data.social_post_comment_user_uuid // either comment's or post's owner uuid, depending on what we're liking
//           }, user: user}), // Convert the credentials object to a JSON string
//           // body: data
//         });

//         response = await response.json()
//         console.log('handleUpvoteResponse', response)
//       if (response.success === true ) {
//         // setSuccess({message: 'The post has been upvoted.'})
//         router.refresh()
//      //    setLoading(false)
//       }
//       else { 
//         setError({message: `There was a problem upvoting this post. Error: ${response.error}`})
//      //    setLoading(false)
//       }
//       // callback({refreshData: true})

            
//         } catch (error) {
//           console.log('error', error)
//           // setLoading(false)
//         }
// }

// const handleDeleteUpvote = async (e) => {
//   e.stopPropagation()
//        try {
//      //    ?id=${target.id}
//      let apiUrl;
//      if (parentComponent === 'THREAD') { // in post thread - deleting comment
//       apiUrl = `/api/social/reactions/${data.social_post_comment_uuid}?user_type=${user.user_type}&record_type=COMMENT`
//      }
//      else { // in all posts (social) - deleting post
//       apiUrl = `/api/social/reactions/${data.social_post_uuid}?user_type=${user.user_type}&record_type=POST`
//      }

//           let response = await fetch(apiUrl, {
//           method: 'DELETE', // if deleting comment, PUT, if deleting post, PUT as well
//           headers: {
//             'Accept': '*/*',
//             'Content-Type': 'application/json'
//           },
//           credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
//           // body: JSON.stringify({data: data, tags: {PRIMARY: selectedPrimaryTags, SECONDARY: selectedSecondaryTags}, user: user}), // Convert the credentials object to a JSON string
//           // body: data
//         });

//         response = await response.json()
//         console.log('handleDeleteResponse', response)
//       if (response.success === true ) {
//         // setSuccess({message: 'The post has been deleted.'})
//         router.refresh()
//      //    setLoading(false)
//       }
//       else { 
//        setError({message: `There was a problem upvoting this post. Error: ${response.error.message}`})
//      //    setLoading(false)
//       }
//       // callback({refreshData: true})

            
//         } catch (error) {
//           console.log('error', error)
//           // setLoading(false)
//         }
// }

// // http://localhost:3000/social?thread=e1b44c47-9bca-4f46-8497-dc2ebc49685b#e1b44c47-9bca-4f46-8497-dc2ebc49685b
// // http://localhost:3000/social?reply-to-uuid=cbdf6c97-9b53-4d78-b739-81d631f424c2&reply-to-handle=bouia#cbdf6c97-9b53-4d78-b739-81d631f424c2
// const handleRespond = async (e) => {
//   e.preventDefault()
//     e.stopPropagation()
//   if (parentComponent === 'THREAD'){ // in root comment thread, this becomes a reply to a comment
//       router.push(`?thread=${searchParams.get('thread')}&reply-to-uuid=${data.social_post_comment_uuid}&reply-to-handle=${data.user_data.user_handle}`, undefined, {shallow:true, scroll:false})
//   }
//   else if (parentComponent === 'INDEX') { // in all posts, this becomes a root comment to a post (we're attaching social/ to searchParams)
//     router.push(`social?thread=${data.social_post_uuid}`, undefined, {shallow:true, scroll:false})
//   }
//   // else if (parentComponent === 'PAGE') { // from social/[post]/page.js
//   //   router.push(`?reply-to-uuid=${data.social_post_comment_uuid}&reply-to-handle=${data.user_data.user_handle}#${data.social_post_comment_uuid}`, undefined, {shallow:true, scroll:false})
//   // }
//   else { // in all posts, this becomes a root comment to a post
//     router.push(`?thread=${data.social_post_uuid}#${data.social_post_uuid}`, undefined, {shallow:true, scroll:false})
//     // #data.socialpostuuid prevents page from jumping up here
//   }
// }





//     const handleChange = (field, value) => {
//      //    setEditedData({
//      //        ...editedData,
//      //        [field]: value
//      //        // [event.target.name]: event.target.value,
//      //    });
//      //    console.log(editedData);
//     };

// // function countComments(comments = []) {
// //   let count = 0;

// //   for (const comment of comments) {
// //     count += 1; // count this comment

// //     if (comment.replies && comment.replies.length > 0) {
// //       count += countComments(comment.replies); // recurse
// //     }
// //   }

// //   return count;
// // }
//         function countComments(comments = []) {
//             let count = 0;

//             for (const comment of comments) {
//                 count += 1; // count this comment

//                 if (comment.replies && comment.replies.length > 0) {
//                 count += countComments(comment.replies); // recurse
//                 }
//             }

//             return count;
//         }



// const renderData = () => {

//   let firstName =data.user_data.user_first_name || ''
//   let lastName = data.user_data.user_last_name || ''

//   let fullName, handle, postBody;

//   if (data.is_anonymous === true) {
//     fullName = 'Anonymous'
//     handle = null
//     postBody = data.social_post_body || data.social_post_comment_body
//   }

//   if (data.status === 'ACTIVE') {
//     fullName = firstName + ' ' + lastName
//     handle = data.user_data.user_handle
//     postBody = data.social_post_body || data.social_post_comment_body
//   }
//   else if (data.status === 'ARCHIVED') {
//     fullName = 'Deleted'
//     handle = 'Deleted'
//     postBody = '[ Deleted ]'
//   }
//   else if (data.status === 'PENDING_REVIEW'){
    
//   }

//   return {fullName: fullName, handle: handle, postBody: postBody}
// }


// // console.log("data@SocialPostSmallCard", data)
// // console.log("replyToUUID", replyToUUID, data.social_post_comment_uuid, data.social_post_comment_body)
//  if ((data.status === 'ACTIVE' || data.status ==='ARCHIVED') || user?.user_roles?.role === 'ROOT' ){
//   // if the post doesn't have thE ACTIVE or ARCHIVED status, hide it (example PENDING_REVIEW) and the user isn't root
//   return (

//  <div onClick={handleRespond} id={data.social_post_uuid || data.social_post_comment_uuid} className={`
//   cursor-pointer ${(parentComponent === 'THREAD' || parentComponent==='PAGE') ? 'bg-slate-50 dark:bg-slate-900' : ''} 
//   hover:bg-slate-100 dark:hover:bg-slate-700
//   ${isNestedComment && 'border-l'} 
//   ${(replyToUUID && replyToUUID === data.social_post_comment_uuid) && 'dark:bg-slate-950 bg-slate-100 border-l-2 border-l-teal-400 dark:border-l-teal-400'} 
//   w-full border-b border-slate-200 dark:border-slate-700 px-4 py-6 transition duration-150 text-base font-inter`}>
//       <Alert state={{success: success, setSuccess: setSuccess, error: error, setError: setError}} message={success ? success.message : error ? error.message : ''}/>

//       {/* Header: Avatar + Name + Timestamp */}
//       <div className="flex items-start gap-3">

//         {/* avatar */}
//         {data.status === 'ACTIVE' && data.is_anonymous === false
//         ? 
//         <Link onClick={e=>e.stopPropagation()} href={`/@${data.user_data.user_handle}`}>
//           <AvatarImage isAnonymous={data.is_anonymous} data={data.user_data} module="USER" size={parentComponent==='THREAD' ? 'xs' : 'sm'} hoverable={true} />
//         </Link> 
//         :
//           data.is_anonymous ? 
//            <AvatarImage isAnonymous={data.is_anonymous} data={data.user_data} module="USER" size={parentComponent==='THREAD' ? 'xs' : 'sm'} hoverable={true} />
//            :
//         <AvatarImage isDeleted={data.status === 'ARCHIVED'} data={data.user_data} module="USER" size={parentComponent==='THREAD' ? 'xs' : 'sm'} hoverable={false} />
//         }

//         {/* name */}
//         <div className="flex flex-col w-full">
//           <div className="flex items-start gap-2 leading-none">











                      
//               <div className="flex flex-col gap-1">
//               <Link onClick={e=>e.stopPropagation()} href={`/@${renderData().handle}`}>
//                 <span className={`hover:underline cursor-pointer dark:text-white font-ubuntu`}>
//                   {renderData().fullName}<br/>
//                 </span>
//                 </Link>
//                 <div className="flex flex-row gap-1">
//                   <Link onClick={e=>e.stopPropagation()} href={`/@${renderData().handle}`}>
//                 <span className="flex items-center text-xs text-slate-400">@{renderData().handle}</span>
//                 </Link>
//                 <span className="flex items-center text-slate-300  text-xs" aria-hidden="true">⋅</span>
//                  <span className="flex items-center text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
//                  </div>

//               </div>
//               {/* :
//               data.is_anonymous ?
//               <div className="flex flex-col gap-1">
//                 <span className={`dark:text-white font-ubuntu`}>
//                 Anonymous
//                 </span>
//                 <span className="text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
//                </div>
//                :
//               <div className="flex flex-col gap-1">
//               <span className={`dark:text-white font-ubuntu`}>
//               Deleted
//               </span>
//                <span className="text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
//                </div>
//             } */}









//             {/* {data.status === 'ACTIVE' && data.is_anonymous === false
//               ? 
//               <div className="flex flex-col gap-1">
//               <Link onClick={e=>e.stopPropagation()} href={`/@${data.user_data.user_handle}`}>
//                 <span className={`hover:underline cursor-pointer dark:text-white font-ubuntu`}>
//                   {data.user_data.user_first_name} {data.user_data.user_last_name}<br/>
//                 </span>
//                 </Link>
//                 <div className="flex flex-row gap-1">
//                   <Link onClick={e=>e.stopPropagation()} href={`/@${data.user_data.user_handle}`}>
//                 <span className="flex items-center text-xs text-slate-400">@{data.user_data.user_handle}</span>
//                 </Link>
//                 <span className="flex items-center text-slate-300  text-xs" aria-hidden="true">⋅</span>
//                  <span className="flex items-center text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
//                  </div>

//               </div>
//               :
//               data.is_anonymous ?
//               <div className="flex flex-col gap-1">
//                 <span className={`dark:text-white font-ubuntu`}>
//                 Anonymous
//                 </span>
//                 <span className="text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
//                </div>
//                :
//               <div className="flex flex-col gap-1">
//               <span className={`dark:text-white font-ubuntu`}>
//               Deleted
//               </span>
//                <span className="text-xs text-slate-400">{dateFormat_2(data.created_date)}</span>
//                </div>
//             } */}

           
//           </div>
          
//           {/* post body + image(s) */}
//           <div className="my-2">
//             {/* Post body */}
//             <div className="mt-1 text-sm font-normal text-slate-800 dark:text-gray-300 whitespace-pre-wrap">
//               {
//               data.status === 'ACTIVE' 
//               ?
//               (parentComponent==='THREAD' ? formatSocialPostBody(data.social_post_comment_body) : formatSocialPostBody (data.social_post_body))
//               :
//               '[ Deleted ]'
//               }
              
//             </div>

//             {/* post topics */}
//             {data.topics && <div className="mt-6 text-sm text-slate-800 dark:text-gray-300 whitespace-pre-wrap flex gap-1">
//               {data.topics.map(t => <TagPill_3 key={t.uuid} href={`/social/topics/${t.topic_name_en}`} caption={t.topic_name_en}/>)}
//               </div>
//               }
//             {/* Post image(s) */}
//             {data.files && <div className="my-4 text-sm text-slate-800 dark:text-gray-300 whitespace-pre-wrap">
//               {data.files?.map(f => {
//                   return <img 
//                     className={'rounded-lg max-h-[500px]'}
//                     key={f.file_uuid}
//                     src={`/assets/social/post_${parentComponent === 'THREAD' ? data.social_post_comment_uuid : data.social_post_uuid}/${f.file_name}`}
//                     />
//               })}

//             </div>}
//           </div>

//           {/* Optional tags or location */}
//           {data.entity_location && (
//             <div className="mt-2 text-xs text-slate-500 dark:text-slate-400">
//               {data.entity_location}
//             </div>
//           )}






//  {/* {user.user_is_root && 
//  <div className="mt-8">
//         <BorderedFrameBox
//         bgColor={'dark:bg-slate-800'}
//                   borderColor="border-teal-400"
//                     title={'ROOT'} 
//                     body={  <TrashButton disabled={false} caption={'ROOT DELETE'} onClick={handleRootDelete} deleteConfirmation={rootDeleteConfirmation}/>}
//                     />
//         </div>
//       } */}
//   <div className="mt-2 flex gap-2 text-xs text-slate-500 dark:text-slate-400">

//      {
//      user?.user_roles?.role === 'ROOT' && 
//     <div className="flex gap-1 items-center">
//       <TrashButton disabled={false} onClick={e=>handleRootDelete(e)} deleteConfirmation={rootDeleteConfirmation}/>
//     <ArrowUpButton disabled={data.status === 'ARCHIVED'} onClick={e=>handlePostUpvote(e)} caption={data.reactions_count} reacted={data.reacted_by_me}/>
//       <div>|</div>
//     </div>
//     }
    


// {
//   /* -------------------------------
//     if user is root 
//     AND 
//     if post doesn't belong to user AND location is not post thread
//     AND
//     post / comment is not deleted
//   ---------------------------------*/
  
//   //   (user?.user_is_root === true || 
//   //   (user?.user_uuid === data.social_post_actor_uuid && parentComponent !== 'THREAD') 
//   // ) && data.is_archived === false 
//   data.status === 'ACTIVE'
//   ? (
//   <>

    
//   {/* if user is owner of comment or post, show trash button */}
//   {
//     ( data.social_post_user_uuid ? user?.user_uuid === data.social_post_user_uuid : user?.user_uuid === data.social_post_comment_user_uuid)
      
//       &&
//       <TrashButton disabled={data.status === 'ARCHIVED'} onClick={e=>handleDelete(e)} deleteConfirmation={deleteConfirmation}/>
//   }
//    <CommentButton disabled={false} onClick={e=>handleRespond(e)} caption={data.comments_count || data.replies?.length || 0}/>
//    <ArrowUpButton disabled={data.status === 'ARCHIVED'} onClick={e=>data.reacted_by_me ? handleDeleteUpvote(e) : handlePostUpvote(e)} caption={data.reactions_count} reacted={data.reacted_by_me}/>
//   {data.social_post_url_short && 
//   // for the time being, we can only copy urls to posts, not post comments
//     <CopyUrlButton disabled={data.status === 'ARCHIVED'} 
//     onClick={e=>{
//     navigator.clipboard.writeText('https://talnet.co/social/' + data.social_post_url_short); e.stopPropagation(); setSuccess({message: 'Post url copied'})}} reacted={data.reacted_by_me}/>}
//    </>)

//   /*-----------------------------------
//     available to everyone (no sign in needed)
//   -------------------------------------*/
//      : parentComponent !== 'THREAD' &&  
//     (   <>
//     <CommentButton disabled={false} onClick={e=>handleRespond(e)} caption={data.comments_count || data.replies?.length || 0}/>
//     <ArrowUpButton disabled={data.status === 'ARCHIVED'} onClick={e=>data.reacted_by_me ? handleDeleteUpvote(e) : handlePostUpvote(e)} caption={data.reactions_count} reacted={data.reacted_by_me}/>
//   </>
// )
// }
//     </div>     
//           {/* Optional reactions bar */}
//           {/* <div className="mt-2 flex gap-6 text-xs text-slate-500 dark:text-slate-400">
//             <span>💬 3</span>
//             <span>🔁 1</span>
//             <span>❤️ 5</span>
//           </div> */}
//         </div>
//       </div>
//     </div>

// // v1
//   //   <div key={data.id}>
//   //   <div
//   //     className="w-full bg-inherit justify-center mx-auto space-y-2 mx-4"
//   //     id={data.id}
//   //   >
//   //     <div
//   //       className={`relative bg-white px-10 py-10 dark:bg-gray-900 overflow-hidden flex flex-col justify-between`}
//   //     >
//   //       <div className="grid grid-cols-12 gap-4">
//   //         <div className="col-span-2 min-w-[80px] max-w-[80px]">
//   //           <Link href={`https://talnet.co/@${data.user_data.user_handle}`}><AvatarImage hoverable={true} data={data.user_data} module={'USER'} size={'sm'}/></Link>
//   //         </div>
//   //         <div className="col-span-10">
//   //           <div className="">
//   //             <div className="hover:underline decoration-2">
//   //           <Link href={`https://talnet.co/@${data.user_data.user_handle}`}><h2>{data.user_data.user_first_name} {data.user_data.user_last_name}</h2></Link>
//   //           </div>
//   //           {/* <div className="">•</div> */}
//   //           {/* <h1 className="">
//   //             <Link
//   //               className="pb-5 hover:text-slate-300 dark:text-slate-200 text-xl font-semibold duration-300 ease-in-out"
//   //               href={`/${lang}/jobs/${data.job_url}`}
//   //             >
//   //               {"data.job_title[lang]"}
//   //             </Link>
//   //           </h1> */}
//   //           <p className="text-xs">{dateFormat_2(data.created_date)}</p>
//   //           </div>
//   //         <div className="my-4">
//   //           {/* PRIMARY TAGS */}
//   //           {/* <div className="mb-1">
//   //             {data.tags.map((tag) => {
//   //               return (
//   //                 tag.tag_type === "PRIMARY" && (
//   //                   <span key={tag.tag_snapshot.id}>
//   //                     <TagPill_1
//   //                       tagType="PRIMARY"
//   //                       iconName={getTagDevIconName(tag.tag_snapshot[`tag_name_en`])}
//   //                       caption={tag[`tag_name_${lang}`]}
//   //                     />
//   //                   </span>
//   //                 )
//   //               );
//   //             })}
//   //           </div> */}
//   //           {/* SECONDARY TAGS */}
//   //           {/* <div>
//   //             {data.tags.map((tag) => {
//   //               return (
//   //                 tag.tag_type === "SECONDARY" && (
//   //                   <span key={tag.tag_snapshot.id}>
//   //                     <TagPill_1
//   //                       tagType="SECONDARY"
//   //                       iconName={getTagDevIconName(tag.tag_snapshot[`tag_name_en`])}
//   //                       caption={tag[`tag_name_${lang}`]}
//   //                       textSize={"xs"}
//   //                     />
//   //                   </span>
//   //                 )
//   //               );
//   //             })}
//   //           </div> */}
//   //         </div>
         
//   //         <h3 className="dark:text-gray-300 text-base">{getEntityLocationStr('job', data)}</h3>
  
//   //         {/* <div className="pt-10 dark:text-gray-300 text-lg font-semibold">
//   //           {lang === "en" ? "Job Description" : "Descriptif"}
//   //         </div> */}
  
//   //         <div className="pt-1 dark:text-gray-300 text-base prose prose-sm whitespace-pre-wrap">
//   //           {/* <ReactMarkdownMod
//   //             args={data.job_description[lang]?.substring(0, 850) + "..."}
//   //           /> */}
//   //           {data.social_post_body}
//   //         </div>
//   //       </div>
//   // </div>
//   //       {/* REACTIONS */}
//   //       {/* <div className="absolute bottom-0 left-0 p-5 w-full bg-white dark:bg-slate-900"> */}
//   //         {/* <div className=" bottom-0 left-0 pt-5 -mb-5 w-full bg-white dark:bg-slate-900">
//   //         <Link href={`/${lang}/jobs/${data.job_url}`}>
//   //           <div className="w-48">
//   //             <TealButton
//   //               caption={
//   //                 lang === "fr" ? (
//   //                   <>
//   //                     Description Complète{" "}
//   //                     <i className="ml-1 fa-solid fa-right-long"></i>
//   //                   </>
//   //                 ) : (
//   //                   <>
//   //                     Full Description{" "}
//   //                     <i className="ml-1 fa-solid fa-arrow-right-long"></i>
//   //                   </>
//   //                 )
//   //               }
//   //             />
//   //           </div>
//   //         </Link>
//   //       </div> */}
//   //     </div>
//   //   </div>
//   // </div>


//   );
//   }
//   else {
//     return;
//   }
// };

// export default SocialPostSmallCard;
